/**** oembed embeddedContent layout overrides ****/
export function initialise(){
    [...document.querySelectorAll("div.embeddedContent")].each(function(el){
        if ( el.dataSet.oembed_provider == 'youtube' || el.dataSet.oembed_provider == 'vimeo'){
            var frame =  el.querySelector('iframe');
            var $w = el.dataSet.maxwidth ? el.dataSet.maxwidth : false;
            var $h = el.dataSet.maxheight ? el.dataSet.maxheight : false;
            if($w) {
                el.classList.add('KMS-video');
                el.clientWidth; // Query the DOM to force a reflow
                frame.style.width = '100%';
            }
            if($h) {
                el.style.maxHeight = $h + "px";
                frame.style.height = '100%';
            }
        }
    });
}